<template lang="pug">
.of-second-background
    oc-section( sectionId='ma', title='Mujeres Adas sin "H"', :tabsContent='tabsContent',nextRef='#eventos', inverted=true )
</template>

<script>
import OcSection from '@/components/shared/Section.vue'
import SECTION from  '@/constants/section-types'

export default {
    components: { OcSection },
    data() {
        return {
            SECTION,
            tabsContent: [
                { 
                    id: 'whatis', 
                    label: '¿Qué es?', 
                    active: true, 
                    content: { 
                        type: SECTION.DEFINITION,
                        img: `${HOMEURL}img/ma/logo.png`,
                        pUrl: 'https://www.youtube.com/embed/B1STXMJCZi0',
                        html: 'Es un <b class="font-weight-bold">curso, taller y libro</b> creado y escrito por la Dra. Mirna Juraidini, para las mujeres en diferentes situaciones de status, belleza, economía y vida como casADAS, separADAS, divorciADAS, quedADAS, enviudADAS, y que se sientan pateADAS, por la vida.<br><br>El desarrollo del cerebro de la mujer, no es igual al desarrollo del cerebro del hombre, aunque el funcionamiento del cerebro es el mismo.<br><br>Si quieres sentirte en equilibrio, cursa o lee MUJERES ADAS SIN "H".'
                    }
                },
                { 
                    id: 'book', 
                    label: 'Libro', 
                    active: false,
                    content: {
                        type: SECTION.BOOK,
                        img: `${HOMEURL}img/ma/book.png`,
                        html: 'Envía tu foto a  para que lo recibas autografíado por la autora. <a href="mailto:mirna@ortografiacerebral.com?Subject=Foto para mi libro autografíado" target="_top">mirna@ortografiacerebral.com</a>',
                        payPalValue: 'LMUNBR3B5W424'
                    } 
                },
                { 
                    id: 'photos', 
                    label: 'Fotos', 
                    active: false,
                    content: {
                        type: SECTION.POTHOS,
                        timeInterval: 20000,
                        slides: [
                            `${HOMEURL}img/ma/slides/1.jpg`,
                            `${HOMEURL}img/ma/slides/2.jpg`,
                            `${HOMEURL}img/ma/slides/3.jpg`,
                            `${HOMEURL}img/ma/slides/4.jpg`,
                            `${HOMEURL}img/ma/slides/5.jpg`
                        ]
                    } 
                }
            ]
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/landing/Section4.vue